import React from 'react';

import { CSSInterpolation } from '@emotion/css/create-instance';
import { CssVars, SelectMenu as SelectMenuComponent } from '@robinhood/design';
import { MenuOptionVariantSelectable } from '@robinhood/design/product/components/MenuOption';
import { Props as ListBoxProps } from '@robinhood/design/product/components/internal/ListBox';

export interface SelectMenuProps extends Omit<ListBoxProps<MenuOptionVariantSelectable>, 'children'> {}

const SelectMenu = (props: SelectMenuProps) => {
  const overrideMenuStyles = React.useMemo<CSSInterpolation>(() => {
    return {
      position: 'relative' as const,

      // Target the button element directly with high specificity
      '& button': {
        border: `1px solid ${CssVars.neutral.bg3}`,
        borderRadius: '12px',
        padding: '12px 24px',
        backgroundColor: CssVars.neutral.bg2,
        height: '56px',

        '&:hover:not(:disabled)': {
          borderColor: CssVars.neutral.fg3,
        },

        '&:focus': {
          borderColor: CssVars.semantic.positive.base,
          outline: 'none',
        },

        '&:disabled': {
          borderColor: CssVars.neutral.bg3,
          cursor: 'not-allowed',
        },

        '&[aria-invalid="true"]': {
          borderColor: CssVars.semantic.error.base,
        },
      },

      // Target text content
      '& button > div:first-of-type > span': {
        fontSize: '15px',
        fontWeight: '400',
      },
    };
  }, []);

  return (
    <SelectMenuComponent
      {...props}
      data-testid='credit-application-select-menu'
      overrideRootStyles={overrideMenuStyles}
    />
  );
};

export default SelectMenu;
